// extracted by mini-css-extract-plugin
export var cardContainer = "_m4-0";
export var cardHeader = "_m4-2";
export var collapsedState = "_m4-3";
export var dragHandle = "_m4-5";
export var dragHandleIcon = "_m4-6";
export var dragging = "_m4-1";
export var titleArea = "_m4-4";